module.exports = __webpack_public_path__ + "img/ico_position_content_on.bf99d27e.svg";